import OpportunityRow from "./OpportunityRow";

export default OpportunityRow;
